import React, { useEffect, useState } from "react";
import { Box, Container } from "@mui/material";
import { useFetchDetail, usePutDetail } from "@hooks/useFetchDetail";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import HeroCst from "@components/HeroCst";
import AddEditFormCst from "@components/AddEditFormCst";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { useFetchTable } from "@hooks/useFetchDataTable";
import { Group } from "src/interfaces/Group";

const EditAttribute: React.FC = () => {
  const { t } = useTranslation(["attributes-page"]);
  const { idAttribute, id } = useParams();
  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
    description?: string;
  }>();

  console.log({ SS: ServicesURL.getAttributes });

  const { columns, dataTable, mutate } = useFetchTable<Group[]>(
    ServicesURL.attributes + `?corporateId=${id}&attributeId=${idAttribute}`,
    PagesID["corporate.attributes"],
    { pageIndex: 0, pageSize: 5 },
  );

  console.log({ dataTable, columns });
  const { trigger: triggerPutAttributes, setId: setPutGroupId } = usePutDetail(
    ServicesURL.attributes,
  );

  useEffect(() => {
    idAttribute && setPutGroupId(idAttribute);
  }, [idAttribute, setPutGroupId]);

  const navigate = useNavigate();

  const onSubmit = async (inputForm: any) => {
    const explore = inputForm["exploreCarousel"] === "true" ? true : false;
    const forY = inputForm["forYou"] === "true" ? true : false;
    const order = Number(inputForm["orderParam"]);
    let objToSend: any = {
      attribute: inputForm["attribute"] || "",
      corporateId: Number(id),
      forYou: forY,
      exploreCarousel: explore,
      orderParam: order,
    };

    try {
      await triggerPutAttributes(objToSend);
      setOpenToast({ s: StatusEnum.OK, message: "" });
    } catch (error) {
      console.error(error);
      setOpenToast(undefined);
    }
    mutate && mutate(inputForm);
  };

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-corp-groups.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst title={t("edit.hero-title")} description={""} />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <AddEditFormCst
              row={
                (dataTable.enrollmentResponses &&
                  dataTable.enrollmentResponses[0]) ||
                {}
              }
              columns={columns}
              onSubmit={onSubmit}
              backButton={() => {
                navigate(`/corporate/${id}/detail/attributes`);
              }}
            />
          </Box>
        )}
        <ModalConfirmsCst
          open={!!openToast}
          title={t("outcome-item", { ns: "modal" })}
          description={t("outcome-item", { ns: "modal" })}
          onCallBackClosed={() => {
            navigate(`/corporate/${id}/detail/attributes`);
          }}
          onActionConfirmed={() => {
            navigate(`/corporate/${id}/detail/attributes`);
          }}
          status={openToast}
        />
      </Container>
    </AnimationFadeIn>
  );
};

export default EditAttribute;
